<template>
  <a href="#" class="btn btn-lg btn-primary btn-lg-square back-to-top" @click.prevent="scrollToTop">
    <i class="bi bi-arrow-up"></i>
  </a>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, ref } from 'vue'

export default defineComponent({
  name: 'BackToTopView',
  setup () {
    const showButton = ref(false)

    const handleScroll = () => {
      if (window.scrollY > 300) {
        showButton.value = true
        const button = document.querySelector('.back-to-top') as HTMLElement
        if (button) {
          button.style.display = 'block'
        }
      } else {
        showButton.value = false
        const button = document.querySelector('.back-to-top') as HTMLElement
        if (button) {
          button.style.display = 'none'
        }
      }
    }

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }

    onMounted(() => {
      window.addEventListener('scroll', handleScroll)
      handleScroll()
    })

    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll)
    })

    return {
      scrollToTop
    }
  }
})
</script>

<style scoped>
.back-to-top {
  position: fixed;
  display: none;
  right: 30px;
  bottom: 30px;
  z-index: 99;
}
</style>
